// Mock data for Paint It Better website

// Services data for Paint It Better
export const services = [
  {
    id: 1,
    name: "Interior Painting",
    slug: "interior-painting",
    shortDescription: "Careful, high-quality decorating for living rooms, bedrooms, halls, stairs and landings. We handle all the preparation, protect your home and work quickly without cutting corners.",
    image: "/images/emergent/interior-kitchen.jpg",
    icon: "Paintbrush"
  },
  {
    id: 2,
    name: "Exterior Painting",
    slug: "exterior-painting",
    shortDescription: "Exterior painting for houses, cottages and period homes across Kent. From weatherboards and sash windows to doors, fences and cabins, we prepare properly and use the right products so it lasts.",
    image: "/images/portfolio/project_01.jpg",
    icon: "Home"
  },
  {
    id: 3,
    name: "Landlords & Rental Properties",
    slug: "landlords-rental-properties",
    shortDescription: "Fast, reliable between-tenant refreshes for portfolio landlords and agents. We work to fixed dates, keep void periods down and send photo and video updates with commentary if you can't be on site.",
    image: "/images/portfolio/project_18.jpg",
    icon: "Building"
  },
  {
    id: 4,
    name: "Offices & Shops",
    slug: "offices-shops",
    shortDescription: "Repaints for offices, clinics and independent shops, planned around opening hours. We keep spaces clean, protect stock and give you a fresh, professional finish without shutting the doors.",
    image: "/images/portfolio/project_02.jpg",
    icon: "Store"
  },
  {
    id: 5,
    name: "Period Properties",
    slug: "period-properties",
    shortDescription: "Specialist decorating for period and listed homes, from sash and timber windows to beams and character features. We use the right products and methods to protect original details while giving you a fresh, clean finish.",
    image: "/images/emergent/period-tudor.jpg",
    icon: "Castle"
  },
  {
    id: 6,
    name: "Clearing & Pressure Cleaning",
    slug: "pressure-washing",
    shortDescription: "Roofs, driveways and decking take the full force of the weather and can quickly build up moss, algae and ground-in dirt. We assess each surface first and use suitable methods, especially on roofs where we focus on controlled, careful cleaning.",
    image: "/images/emergent/pressure-cleaning.jpg",
    icon: "Droplets"
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: "Complete Exterior 5 Bedroom House",
    category: "Exterior Painting",
    image: "/images/portfolio/project_01.jpg",
    description: "Full exterior painting of large 5 bedroom property including all woodwork, fascias and render"
  },
  {
    id: 2,
    title: "Large Office Refresh",
    category: "Interior Painting",
    image: "/images/portfolio/project_02.jpg",
    description: "Complete office interior redecoration with modern color scheme and professional finish"
  },
  {
    id: 3,
    title: "Beautiful & Detailed Renovation Works",
    category: "Interior Painting",
    image: "/images/portfolio/project_03.jpg",
    description: "Detailed interior renovation with careful attention to period features and architectural details"
  },
  {
    id: 4,
    title: "Lovely Kitchen Refresh",
    category: "Interior Painting",
    image: "/images/portfolio/project_04.jpg",
    description: "Kitchen walls and ceiling refresh with moisture-resistant paint for lasting finish"
  },
  {
    id: 5,
    title: "Big Interior Job with Precision Cutting In",
    category: "Interior Painting",
    image: "/images/portfolio/project_05.jpg",
    description: "Large scale interior painting project featuring precise cutting in and professional finish throughout"
  },
  {
    id: 6,
    title: "Complete Sitting Room",
    category: "Interior Painting",
    image: "/images/portfolio/project_06.jpg",
    description: "Full sitting room transformation with walls, ceiling and woodwork beautifully finished"
  },
  {
    id: 7,
    title: "Bungalow Exterior Like New",
    category: "Exterior Painting",
    image: "/images/portfolio/project_07.jpg",
    description: "Complete bungalow exterior refresh bringing the property back to pristine condition"
  },
  {
    id: 8,
    title: "Sash Windows to Canterbury Cottage",
    category: "Exterior Painting",
    image: "/images/portfolio/project_08.jpg",
    description: "Restoration and painting of traditional sash windows on charming Canterbury cottage"
  },
  {
    id: 9,
    title: "Whole Interior to Period House",
    category: "Interior Painting",
    image: "/images/portfolio/project_09.jpg",
    description: "Sympathetic complete interior redecoration of period property respecting original features"
  },
  {
    id: 10,
    title: "Dormer Restoration",
    category: "Exterior Painting",
    image: "/images/portfolio/project_10.jpg",
    description: "Expert restoration and painting of dormer windows and surrounding exterior woodwork"
  },
  {
    id: 11,
    title: "Complete Apartment Revamp",
    category: "Interior Painting",
    image: "/images/portfolio/project_11.jpg",
    description: "Total apartment interior transformation with modern colors and flawless finish"
  },
  {
    id: 12,
    title: "Cottage Exterior",
    category: "Exterior Painting",
    image: "/images/portfolio/project_12.jpg",
    description: "Charming cottage exterior painting including render and all external woodwork"
  },
  {
    id: 13,
    title: "Grade II Listed Property",
    category: "Exterior Painting",
    image: "/images/portfolio/project_13.jpg",
    description: "Careful restoration work on Grade II listed property using appropriate heritage materials"
  },
  {
    id: 14,
    title: "High-End Kitchen Redecoration",
    category: "Interior Painting",
    image: "/images/portfolio/project_14.jpg",
    description: "Luxury kitchen redecoration with premium finishes and attention to every detail"
  },
  {
    id: 15,
    title: "New Build Decorating",
    category: "Interior Painting",
    image: "/images/portfolio/project_15.jpg",
    description: "New build property complete interior decoration with modern neutral palette"
  },
  {
    id: 16,
    title: "Whole House Painted & Garden Refreshed",
    category: "Exterior Painting",
    image: "/images/portfolio/project_16.jpg",
    description: "Complete house exterior painting plus garden structures and fencing restoration"
  },
  {
    id: 17,
    title: "Exterior House Refresh",
    category: "Exterior Painting",
    image: "/images/portfolio/project_17.jpg",
    description: "Full exterior property refresh including walls, windows and all outdoor woodwork"
  },
  {
    id: 18,
    title: "Interior with Large Banisters",
    category: "Interior Painting",
    image: "/images/portfolio/project_18.jpg",
    description: "Interior decoration featuring impressive staircase with detailed banister painting"
  },
  {
    id: 19,
    title: "Loft Room Conversion",
    category: "Interior Painting",
    image: "/images/portfolio/project_19.jpg",
    description: "Loft room decoration creating beautiful additional living space"
  },
  {
    id: 20,
    title: "Exterior Woodwork Repair & Paint",
    category: "Exterior Painting",
    image: "/images/portfolio/project_20.jpg",
    description: "Expert repair and repainting of all exterior woodwork restoring weather protection"
  },
  {
    id: 21,
    title: "Period Property Refurbishment",
    category: "Interior Painting",
    image: "/images/portfolio/project_21.jpg",
    description: "Light refurbishment and decorating in period property with respectful approach"
  },
  {
    id: 22,
    title: "Complete Room Refresh",
    category: "Interior Painting",
    image: "/images/portfolio/project_22.jpg",
    description: "Room refreshed from top to bottom with walls, ceiling and all details perfected"
  }
];

// Team members (keeping for About page)
export const teamMembers = [
  {
    id: 1,
    name: "Romeo",
    role: "Lead Decorator",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400",
    description: "With over 15 years of experience, Romeo leads our team with expertise and dedication to quality."
  }
];

export const stats = [
  { label: "Years Experience", value: "15+" },
  { label: "Projects Completed", value: "500+" },
  { label: "Happy Customers", value: "450+" },
  { label: "5-Star Reviews", value: "98%" }
];